/* eslint-disable react/no-array-index-key, react/no-danger */
import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import { scroller } from 'react-scroll';
import Headroom from 'react-headroom';
import { connectURL } from 'constants/defaultValues';
import Features from 'sections/home/features';
import Rewards from 'sections/home/rewards';
import Compensation from 'sections/home/compensation';
import Solutions from 'sections/home/solutions';
import FounderMessage from 'sections/home/founderMessage';
import Hero from 'sections/home/hero';
import CustomerLogos from 'sections/home/customerLogos';

const navItems = [
    { label: 'FEATURES', value: 'features' },
    { label: 'REWARDS', value: 'rewards' },
    { label: 'COMPENSATION', value: 'compensation' },
    { label: 'SOLUTIONS', value: 'solutions' },
];

const Home = () => {
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const refRowHome = useRef(null);
    const refSectionHome = useRef(null);
    const refSectionFooter = useRef(null);

    const onWindowResize = (event) => {
        const homeRect = refRowHome.current.getBoundingClientRect();

        const homeSection = refSectionHome.current;
        homeSection.style.backgroundPositionX = `${homeRect.x - 580}px`;

        const footerSection = refSectionFooter.current;
        footerSection.style.backgroundPositionX = `${event.target.innerWidth - homeRect.x - 2000
            }px`;

        if (event.target.innerWidth >= 992) {
            setShowMobileMenu(false);
        }
    };

    const onWindowClick = () => {
        setShowMobileMenu(false);
    };

    const onWindowScroll = () => {
        setShowMobileMenu(false);
    };

    const onKeyDown = (event) => {
        if (event.key === 'Escape') {
            setShowMobileMenu(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', onWindowScroll);
        window.addEventListener('resize', onWindowResize);
        window.addEventListener('click', onWindowClick);
        window.addEventListener('keydown', onKeyDown);

        document.body.classList.add('no-footer');
        return () => {
            window.removeEventListener('scroll', onWindowScroll);
            window.removeEventListener('resize', onWindowResize);
            window.removeEventListener('click', onWindowClick);
            window.removeEventListener('keydown', onKeyDown);
            document.body.classList.remove('no-footer');
        };
    }, []);

    const scrollTo = (event, target) => {
        event.preventDefault();
        scroller.scrollTo(target, {
            duration: 500,
            delay: 0,
            smooth: 'easeInOutQuart',
            offset: -100,
        });
        return false;
    };

    return (
        <div
            className={classnames('landing-page', {
                'show-mobile-menu': showMobileMenu,
            })}
        >
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div className="mobile-menu" onClick={(event) => event.stopPropagation()}>
                <a
                    className="logo-mobile c-pointer"
                    href="#scroll"
                    onClick={(event) => scrollTo(event, 'home')}
                >
                    <span />
                </a>
                <ul className="navbar-nav">
                    {navItems.map((item, index) => (
                        <li className="nav-item" key={index}>
                            <a
                                className="c-pointer"
                                href="#scroll"
                                onClick={(event) => scrollTo(event, item.value)}
                            >
                                {item.label}
                            </a>
                        </li>
                    ))}

                    <li className="nav-item text-center">
                        <a
                            className="btn btn-outline-primary btn-sm mobile-menu-cta"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={connectURL}
                        >
                            Talk to us
                        </a>
                    </li>
                </ul>
            </div>

            <div className="main-container">
                <Headroom className="landing-page-nav">
                    <nav>
                        <div className="container d-flex align-items-center justify-content-between">
                            <a
                                className="navbar-logo pull-left c-pointer"
                                href="#scroll"
                                onClick={(event) => scrollTo(event, 'home')}
                            >
                                <span className="white" />
                                <span className="dark" />
                            </a>
                            <ul className="navbar-nav d-none d-lg-flex flex-row">
                                {navItems.map((item, index) => (
                                    <li className="nav-item" key={index}>
                                        <a
                                            className="c-pointer"
                                            href="#scroll"
                                            onClick={(event) => scrollTo(event, item.value)}
                                        >
                                            {item.label}
                                        </a>
                                    </li>
                                ))}
                                <li className="nav-item pl-4">
                                    <a
                                        className="btn btn-outline-semi-light btn-sm pr-4 pl-4"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={connectURL}
                                    >
                                        Talk to us
                                    </a>
                                </li>
                            </ul>
                            <button
                                type="button"
                                className="mobile-menu-button"
                                aria-label="Toggle navigation menu"
                                aria-expanded={showMobileMenu}
                                onClick={(event) => {
                                    setShowMobileMenu(!showMobileMenu);
                                    event.stopPropagation();
                                }}
                            >
                                <i className="simple-icon-menu" />
                            </button>
                        </div>
                    </nav>
                </Headroom>
                <div className="content-container" id="home">
                    <Hero
                        scrollTo={scrollTo}
                        refRowHome={refRowHome}
                        refSectionHome={refSectionHome}
                    />
                    <CustomerLogos />
                    <Features />
                    <FounderMessage />
                    <Rewards />
                    <Compensation />
                    <Solutions />

                    <div className="section background background-no-bottom mb-0 pb-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 offset-0 col-lg-8 offset-lg-2 text-center">
                                    <h2>Ready To Work With WellPay?</h2>
                                </div>
                                <div className="col-12 offset-0 col-lg-6 offset-lg-3 newsletter-input-container">
                                    <div className="text-center mb-3">
                                        <a
                                            className="btn btn-secondary btn-xl"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={connectURL}
                                        >
                                            Talk to us
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="section footer mb-0" ref={refSectionFooter}>
                        <div className="container">
                            <div className="row footer-row">
                                <div className="col-12 text-right">
                                    <a
                                        className="btn btn-circle btn-outline-semi-light footer-circle-button c-pointer"
                                        href="#scroll"
                                        onClick={(event) => scrollTo(event, 'home')}
                                    >
                                        <i className="simple-icon-arrow-up" />
                                    </a>
                                </div>
                                <div className="col-12 text-center footer-content">
                                    <a
                                        className="c-pointer"
                                        href="#scroll"
                                        onClick={(event) => scrollTo(event, 'home')}
                                    >
                                        <img
                                            className="footer-logo"
                                            alt="footer logo"
                                            src="/assets/logos/white-full.svg"
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="container copyright pt-5 pb-5">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <a href="/privacy" className="footer-privacy-link">Privacy Policy</a>
                                    <span className="footer-link-separator"> · </span>
                                    <a href="/terms" className="footer-privacy-link">Terms of Service</a>
                                    <span className="footer-link-separator"> · </span>
                                    <a href="/security" className="footer-privacy-link">Security</a>
                                    <span className="footer-link-separator"> · </span>
                                    <a href="/support" className="footer-privacy-link">Support</a>
                                    <span className="footer-link-separator"> · </span>
                                    <a href="https://wellpay.instatus.com/" target="_blank" rel="noopener noreferrer" className="footer-privacy-link">App Status</a>
                                </div>
                                <div className="col-12" />
                                <div className="col-12 text-center">
                                    <p className="mb-0">2026 &copy; WellPay</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;